<app-form-supervbase
    [dataItem]="dataItem"
    [groupList]="groupList"
    [userList]="userList"
    [basketList]="basketList"    
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)"
>
</app-form-supervbase>
